import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "authentication-register-group" }
const _hoisted_2 = { class: "side" }
const _hoisted_3 = { class: "side-text-wrap" }
const _hoisted_4 = { href: "/" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "line-wrap" }
const _hoisted_7 = { class: "step" }
const _hoisted_8 = {
  key: 0,
  class: "bulletActive"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#ffffff"}
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_12 = { class: "step" }
const _hoisted_13 = {
  key: 0,
  class: "bulletActive"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#ffffff"}
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_17 = { class: "step" }
const _hoisted_18 = {
  key: 0,
  class: "bulletActive"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#ffffff"}
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "switch" }
const _hoisted_22 = {
  class: "text-uppercase",
  style: {"margin-right":"18px"}
}
const _hoisted_23 = {
  class: "text-uppercase",
  style: {"margin-left":"5px"}
}
const _hoisted_24 = { class: "form-container" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "text-dark auth-language-dropdown" }
const _hoisted_27 = { class: "mobile-line-wrap" }
const _hoisted_28 = { class: "step-wrap" }
const _hoisted_29 = { class: "step" }
const _hoisted_30 = {
  key: 0,
  class: "bulletActive"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#ffffff"}
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "step-name" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_35 = { class: "step-wrap" }
const _hoisted_36 = { class: "step" }
const _hoisted_37 = {
  key: 0,
  class: "bulletActive"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#ffffff"}
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "step-name" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_42 = { class: "step-wrap" }
const _hoisted_43 = { class: "step" }
const _hoisted_44 = {
  key: 0,
  class: "bulletActive"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#ffffff"}
}, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "step-name" }
const _hoisted_48 = { class: "form-outer mx-sm-0 mx-md-5 mx-lg-0" }
const _hoisted_49 = {
  key: 0,
  class: "title"
}
const _hoisted_50 = {
  key: 1,
  class: "title"
}
const _hoisted_51 = { class: "subtitle" }
const _hoisted_52 = { class: "mb-6" }
const _hoisted_53 = { class: "label mb-1 required" }
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "mb-6" }
const _hoisted_57 = { class: "d-flex justify-content-between" }
const _hoisted_58 = { class: "label mb-1 required" }
const _hoisted_59 = { class: "mobile-font" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { class: "forgot" }
const _hoisted_65 = { class: "mb-6" }
const _hoisted_66 = { class: "d-flex justify-content-between" }
const _hoisted_67 = { class: "label mb-1 required" }
const _hoisted_68 = { class: "mobile-font" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = {
  class: "nextBtn",
  type: "submit"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-arrow-left fa-xl",
  style: {"line-height":"0"}
}, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "mb-9" }
const _hoisted_77 = {
  key: 0,
  class: "title"
}
const _hoisted_78 = {
  key: 1,
  class: "title"
}
const _hoisted_79 = { class: "step2-subtitle" }
const _hoisted_80 = { class: "mobile-title" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-left fa-sm" }, null, -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-6 mb-4" }
const _hoisted_85 = { class: "label mb-1 required" }
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = { class: "col-6 mb-4" }
const _hoisted_89 = { class: "label mb-1 required" }
const _hoisted_90 = { class: "fv-plugins-message-container" }
const _hoisted_91 = { class: "fv-help-block" }
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-lg-6 mb-4" }
const _hoisted_94 = {
  class: "label mb-1 required",
  style: {"min-width":"120px"}
}
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = {
  key: 0,
  class: "col-lg-6 mb-4"
}
const _hoisted_98 = { class: "label mb-1" }
const _hoisted_99 = { class: "fv-plugins-message-container" }
const _hoisted_100 = { class: "fv-help-block" }
const _hoisted_101 = { class: "col-lg-6 mb-4" }
const _hoisted_102 = { class: "label mb-1 required" }
const _hoisted_103 = { class: "fv-plugins-message-container" }
const _hoisted_104 = { class: "fv-help-block" }
const _hoisted_105 = {
  key: 0,
  class: "checkboxContainer"
}
const _hoisted_106 = ["href"]
const _hoisted_107 = ["href"]
const _hoisted_108 = ["href"]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_110 = { key: 1 }
const _hoisted_111 = {
  key: 2,
  class: "checkboxContainer mt-2"
}
const _hoisted_112 = ["href"]
const _hoisted_113 = ["href"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_115 = {
  key: 3,
  class: "checkboxContainer mt-2"
}
const _hoisted_116 = ["href"]
const _hoisted_117 = ["href"]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_119 = ["disabled"]
const _hoisted_120 = { class: "indicator-label" }
const _hoisted_121 = { class: "indicator-progress" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_123 = { class: "page" }
const _hoisted_124 = { class: "mobile-title" }
const _hoisted_125 = { class: "final-wrap mt-9" }
const _hoisted_126 = { class: "finalMessage" }
const _hoisted_127 = { href: "#" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_129 = { class: "finalMessage" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_131 = { class: "finalMessage" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("img", {
  class: "web-final-icon",
  src: "/images/auth/signup-final-icon.png",
  alt: ""
}, null, -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "mobile-final-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/auth/mobile-signup-final-icon.png",
    alt: ""
  })
], -1)
const _hoisted_134 = { class: "mobile-switch" }
const _hoisted_135 = {
  class: "text-uppercase",
  style: {"margin-right":"18px"}
}
const _hoisted_136 = {
  class: "text-uppercase",
  style: {"margin-left":"5px"}
}

import * as Yup from "yup";
import axios from "axios";
import { useStore } from "@/store";
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Actions } from "@/store/enums/StoreEnums";
import { getRegionCodes } from "@/core/data/phonesData";
import AuthSwitch from "../../components/AuthSwitch.vue";
import { Field, ErrorMessage, Form } from "vee-validate";
import LanguageDropdown from "../../components/LanguageDropdown.vue";
import { useI18n } from "vue-i18n";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import { event } from "vue-gtag";
import ClientGlobalService from "@/projects/client/services/ClientGlobalService";
import { SiteTypes } from "@/core/types/SiteTypes";
import { getBaDocs, getBviDocs, baDocs, bviDocs } from "@/core/data/bcrDocs";
import {
  getTenancy,
  getTenantLogo,
  TenantTypes,
  tenancies,
} from "@/core/types/TenantTypes";
import { isIsecDomain, isBblDomain } from "@/core/types/domainList";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUp',
  props: {
  code: { type: String, required: false },
},
  setup(__props) {

const props = __props;



const processes = ref(1);
const store = useStore();
const i18n = useI18n();
const { t } = i18n;
const router = useRouter();
const authType = ref(true);
const checked = ref(true);
const checkedTwo = ref(false);
const formData = ref<any>({});
const passwordShow_1 = ref(false);
const passwordShow_2 = ref(false);
const smsInterval = ref(0);
const tenantNo = ref<any>(TenantTypes.bvi);
const phoneRegionCode = ref("");
const regionCodes = ref(getRegionCodes());
const submitButton = ref<HTMLButtonElement | null>(null);
// const formOneKey = ref(0);
// const formTwoKey = ref(0);
const route = useRoute();
const language = ref<any>();
const c = ref([] as any);

const initFormData = () => {
  var passInLang = route.query.lang as string;

  language.value = passInLang || i18n.locale.value || LanguageTypes.enUS;

  if (language.value == "zh-hk") {
    language.value = "zh-tw";
  } else if (language.value == "id-id") {
    language.value = "en-us";
  }

  i18n.locale.value = language.value;
  localStorage.setItem("language", language.value);

  var confirmUrl =
    window.location.protocol + "//" + window.location.host + "/confirm-email";
  if (window.location.href.includes("portal")) {
    confirmUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/portal/confirm-email";
  }
  formData.value = {
    language: language.value,
    confirmUrl: confirmUrl,
  };

  if (props.code) {
    formData.value.referCode = props.code;
  }

  phoneRegionCode.value = "";
};

const configTenantId = () => {
  // var tenantId = route.query.tenantId as string;
  var tenantId = parseInt(route.query.tenantId as string, 10);

  if (tenantId) {
    setCookie("tenantId", tenantId.toString(), 30);
  } else {
    const cookieTenantId = getCookie("tenantId");
    tenantId = cookieTenantId ? parseInt(cookieTenantId, 10) : tenantId;
  }

  if (isIsecDomain()) {
    tenantId = TenantTypes.jp;
    checkedTwo.value = true;
  }

  tenantNo.value = tenantId;
  if (tenantId == TenantTypes.au) {
    checked.value = false;
  }
  if (tenantId) {
    formData.value.tenantId = tenantId;
  }
  if (tenantId == TenantTypes.au) {
    regionCodes.value = getRegionCodes(["au", "cn", "hk", "tw", "vn", "jp"]);
  }
};

const configUtm = () => {
  var utm = route.query.utm as string;
  if (utm) {
    setCookie("utm", utm, 7);
    formData.value.utm = utm;
  }
};

const configCode = () => {
  var code = route.query.code as string;

  if (code) {
    setCookie("code", code, 30);
  }

  code = getCookie("code") ?? "";

  if (code) {
    formData.value.code = code;
  }
};

const setCookie = (name: string, value: string, days: number) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const getC = async () => {
  try {
    const openAt = route.query.open_at as string;
    let res;
    if (openAt) {
      res = await axios.get("/api/v1/auth/c?openAt=" + openAt);
    } else {
      res = await axios.get("/api/v1/auth/c");
    }
    c.value = res.data;

    // Set the tenantId based on the c value
    if (getTenancy.value == tenancies.au) {
      c.value = [SiteTypes.Australia];
      formData.value.tenantId = TenantTypes.au;
    }
    if (isBblDomain()) {
      c.value = [SiteTypes.BBL];
    }

    window.localStorage.setItem("c", c.value);
    if (c.value[0] == SiteTypes.Australia) {
      checked.value = false;
    }
  } catch (error) {
    console.error(error);
  }
};

const toggleAuthType = (_authType) => {
  authType.value = _authType;
  router.push({ name: "sign-in", query: router.currentRoute.value.query });
};

const step1_validationSchema = ref(createValidationSchema());
function createValidationSchema() {
  return Yup.object().shape({
    email: Yup.string()
      .email(t("error.__EMAIL_IS_REQUIRED__"))
      .required(t("error.__EMAIL_IS_REQUIRED__")),
    password: Yup.string()
      .min(8, t("error.signup_ps_8"))
      .matches(/[a-z]/, t("error.signup_ps_lower"))
      .matches(/[A-Z]/, t("error.signup_ps_upper"))
      .matches(/\d/, t("error.signup_ps_number"))
      .matches(/[!@#$%^&*(),.?":{}|<>]/, t("error.signup_ps_symbol"))
      .required(t("error.signup_ps_require")),
    confirmPassword: Yup.string()
      .required(t("error.signup_cps_require"))
      .oneOf([Yup.ref("password"), null], t("error.signup_ps_match")),
  });
}

const step2_validationSchema = ref(createValidation2Schema());
function createValidation2Schema() {
  return Yup.object().shape({
    FirstName: Yup.string().required(t("error.__FIRST_NAME_IS_REQUIRED__")),
    LastName: Yup.string().required(t("error.__LAST_NAME_IS_REQUIRED__")),
    countryCode: Yup.string().required(t("error.__NATIONALITY_IS_REQUIRED")),
    phone: Yup.string().required(t("error.__PHONE_NUMBER_IS_REQUIRED__")),
    // otpCode: Yup.string().required().label("OPT Code"),
    // otpCode: Yup.string().when({
    //   is: projectConfig.value.smsValidationEnabled,
    //   then: Yup.string().required().label("OPT Code"),
    // }),
  });
}

const sendOtpCode = async () => {
  try {
    await ClientGlobalService.sendOneTimeCodeForPhone(
      formData.value.ccc,
      formData.value.phone
    );

    MsgPrompt.success(t("tip.verificationCodeSend")).then(() => {
      smsInterval.value = 60;
      const interval = setInterval(() => {
        smsInterval.value--;
        if (smsInterval.value <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const onSubmitRegister = async () => {
  await store.dispatch(Actions.LOGOUT);
  formData.value.otp = 771578;
  if (!submitButton.value) {
    return;
  }
  submitButton.value.disabled = true;
  submitButton.value.setAttribute("data-kt-indicator", "on");

  try {
    await ClientGlobalService.registerNewUser({
      ...formData.value,
      siteId: c.value[0],
    });
    event("conversion", { send_to: process.env.VUE_APP_GA_SIGNUP_EVENT });
    MsgPrompt.success(t("tip.registerSuccess")).then(() => {
      // disable email confirm page, route to login page after register success
      // next();
      router.push({ name: "sign-in" });
    });
  } catch (error) {
    const err = error as any;
    if (
      err.response.data.message === "__EMAIL_EXISTS__" ||
      err.response.status == 409
    ) {
      MsgPrompt.error(t("tip.emailExists"));
    } else {
      MsgPrompt.error(error);
    }
    goFirst();
  }

  submitButton.value.disabled = false;
  submitButton.value.setAttribute("data-kt-indicator", "off");
};

const resendConfirmation = async () => {
  try {
    await ClientGlobalService.resendConfirmationEmail(
      formData.value.email,
      formData.value.confirmUrl
    );

    MsgPrompt.success(t("tip.confirmationEmailResend"));
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const prev = () => {
  processes.value -= 1;
};

const next = () => {
  processes.value += 1;
};

const goFirst = () => {
  processes.value = 1;
};

const goLogin = () => {
  router.push({ name: "sign-in" });
};

onMounted(() => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  initFormData();
  configTenantId();
  configCode();
  configUtm();
  getC();
});

watch(phoneRegionCode, () => {
  formData.value.ccc = regionCodes.value[phoneRegionCode.value]?.dialCode;
});

watch(i18n.locale, (newValue) => {
  // console.log(step1_validationSchema.value);
  if (newValue === "zh-hk") {
    language.value = "zh-tw";
    formData.value.language = "zh-tw";
  } else if (newValue === "id-id") {
    language.value = "en-us";
    formData.value.language = "en-us";
  } else {
    language.value = newValue;
    formData.value.language = newValue;
  }

  step1_validationSchema.value = createValidationSchema();
  step2_validationSchema.value = createValidation2Schema();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("img", {
            class: "logo",
            src: _unref(getTenantLogo)['src']
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (processes.value >= 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          (processes.value >= 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true)
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (processes.value == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("action.login")), 1),
        _createVNode(AuthSwitch, {
          isEnabled: authType.value,
          color: "#F5BF21",
          onToggleAuthType: toggleAuthType
        }, null, 8, ["isEnabled"]),
        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("action.register")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "mobile-logo",
          src: _unref(getTenantLogo)['src']
        }, null, 8, _hoisted_25)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(LanguageDropdown)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            (processes.value >= 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("fields.email")), 1)
        ]),
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            (processes.value >= 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("fields.personalDetail")), 1)
        ]),
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            (processes.value == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("fields.verify")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        (processes.value == 1)
          ? (_openBlock(), _createBlock(_unref(Form), {
              key: 0,
              onSubmit: next,
              "validation-schema": step1_validationSchema.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (tenantNo.value == _unref(TenantTypes).jp)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.$t("tip.createAnIsecAccount")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.$t("tip.createBcrAccount")), 1)),
                  _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("tip.enterAccountDetailsBelow")), 1),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("fields.email")), 1),
                    _createVNode(_unref(Field), {
                      modelValue: formData.value.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                      tabindex: "1",
                      class: "form-control form-control-lg form-control-solid",
                      type: "text",
                      name: "email",
                      autocomplete: "off"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
                          autocomplete: "off",
                          clearable: "",
                          size: "large"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_unref(ErrorMessage), { name: "email" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("fields.password")), 1),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa-solid fa-lg eye-icon", passwordShow_1.value ? 'fa-eye-slash' : 'fa-eye']),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (passwordShow_1.value = !passwordShow_1.value))
                        }, null, 2),
                        (passwordShow_1.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t("action.hide")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t("action.show")), 1))
                      ])
                    ]),
                    _createVNode(_unref(Field), {
                      modelValue: formData.value.password,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.password) = $event)),
                      tabindex: "2",
                      class: "mt-1 form-control form-control-lg form-control-solid",
                      type: passwordShow_1.value ? 'text' : 'password',
                      name: "password",
                      autocomplete: "off"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.password,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.password) = $event)),
                          type: passwordShow_1.value ? 'text' : 'password',
                          size: "large",
                          placeholder: _ctx.$t('tip.inputPassword'),
                          clearable: ""
                        }, null, 8, ["modelValue", "type", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "type"]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_unref(ErrorMessage), { name: "password" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("tip.use8CharWithMixLetterAndNumberAndSymbol")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t("fields.confirmedPassword")), 1),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa-solid fa-lg eye-icon", passwordShow_2.value ? 'fa-eye-slash' : 'fa-eye']),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (passwordShow_2.value = !passwordShow_2.value))
                        }, null, 2),
                        (passwordShow_2.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.$t("action.hide")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.$t("action.show")), 1))
                      ])
                    ]),
                    _createVNode(_unref(Field), {
                      modelValue: formData.value.confirmPassword,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.confirmPassword) = $event)),
                      tabindex: "3",
                      class: "mt-1 form-control form-control-lg form-control-solid",
                      type: passwordShow_2.value ? 'text' : 'password',
                      name: "confirmPassword",
                      autocomplete: "off"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.confirmPassword,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.confirmPassword) = $event)),
                          type: passwordShow_2.value ? 'text' : 'password',
                          size: "large",
                          placeholder: _ctx.$t('tip.inputPassword'),
                          clearable: ""
                        }, null, 8, ["modelValue", "type", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "type"]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_unref(ErrorMessage), { name: "confirmPassword" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("button", _hoisted_73, _toDisplayString(_ctx.$t("action.next")), 1)
              ]),
              _: 1
            }, 8, ["validation-schema"]))
          : _createCommentVNode("", true),
        (processes.value == 2)
          ? (_openBlock(), _createBlock(_unref(Form), {
              key: 1,
              onSubmit: onSubmitRegister,
              "validation-schema": step2_validationSchema.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "prev",
                  onClick: prev
                }, _hoisted_75),
                _createElementVNode("div", _hoisted_76, [
                  (tenantNo.value == _unref(TenantTypes).jp)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.$t("tip.createAnIsecAccount")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.$t("tip.createBcrAccount")), 1)),
                  _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.$t("tip.enterAccountDetailsBelow")), 1),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t("title.enterYourInfo")), 1),
                    _createElementVNode("div", {
                      class: "mobile-prev",
                      onClick: prev
                    }, _hoisted_82)
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t("fields.firstName")), 1),
                      _createVNode(_unref(Field), {
                        modelValue: formData.value.FirstName,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.FirstName) = $event)),
                        class: "mt-1 form-control form-control-lg form-control-solid",
                        type: "text",
                        name: "FirstName",
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.FirstName,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.FirstName) = $event)),
                            placeholder: _ctx.$t('tip.pleaseInput'),
                            size: "large"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createVNode(_unref(ErrorMessage), { name: "FirstName" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t("fields.lastName")), 1),
                      _createVNode(_unref(Field), {
                        modelValue: formData.value.LastName,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.LastName) = $event)),
                        class: "mt-1 form-control form-control-lg form-control-solid",
                        type: "text",
                        name: "LastName",
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.LastName,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.LastName) = $event)),
                            placeholder: _ctx.$t('tip.pleaseInput'),
                            size: "large"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createVNode(_unref(ErrorMessage), { name: "LastName" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t("fields.countryAndRegion")), 1),
                      _createVNode(_unref(Field), {
                        modelValue: formData.value.countryCode,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.countryCode) = $event)),
                        className: "mt-1 form-control form-control-lg form-control-solid",
                        name: "countryCode",
                        autoComplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.countryCode,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.countryCode) = $event)),
                            placeholder: _ctx.$t('tip.selectCountry'),
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (phoneRegionCode.value = formData.value.countryCode)),
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.name,
                                  value: item.code
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createVNode(_unref(ErrorMessage), { name: "countryCode" })
                        ])
                      ])
                    ]),
                    (c.value[0] != _unref(SiteTypes).Australia && tenantNo.value != _unref(TenantTypes).jp)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                          _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("fields.referralCode")), 1),
                          _createVNode(_unref(Field), {
                            modelValue: formData.value.referCode,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.referCode) = $event)),
                            class: "mt-1 form-control form-control-lg form-control-solid",
                            type: "text",
                            name: "referCode",
                            autocomplete: "off",
                            disabled: props.code != undefined ? true : false
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: formData.value.referCode,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.referCode) = $event)),
                                placeholder: _ctx.$t('tip.pleaseInput'),
                                size: "large",
                                disabled: props.code != undefined ? true : false
                              }, null, 8, ["modelValue", "placeholder", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"]),
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              _createVNode(_unref(ErrorMessage), { name: "referCode" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.$t("fields.phoneNum")), 1),
                      _createVNode(_unref(Field), {
                        modelValue: formData.value.phone,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.phone) = $event)),
                        class: "mt-1 form-control form-control-lg form-control-solid",
                        type: "text",
                        name: "phone",
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.phone,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.phone) = $event)),
                            placeholder: _ctx.$t('tip.pleaseInput'),
                            size: "large"
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                size: "large",
                                placeholder: _ctx.$t('action.select'),
                                modelValue: phoneRegionCode.value,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((phoneRegionCode).value = $event)),
                                style: {"width":"175px"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.code,
                                      label: `${item.name} +${item.dialCode}`,
                                      value: item.code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["placeholder", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("div", _hoisted_104, [
                          _createVNode(_unref(ErrorMessage), { name: "phone" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  (c.value[0] == _unref(SiteTypes).Australia || tenantNo.value == _unref(TenantTypes).au)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_105, [
                        _createTextVNode(_toDisplayString(_ctx.$t("tip.pleaseEnsure")) + " ", 1),
                        _createElementVNode("a", {
                          href: _unref(getBaDocs)(_unref(baDocs).productDisclosureDocument.title),
                          target: "_blank"
                        }, _toDisplayString(_ctx.$t(`title.${_unref(baDocs).productDisclosureDocument.title}`)), 9, _hoisted_106),
                        _createTextVNode(" , "),
                        _createElementVNode("a", {
                          href: _unref(getBaDocs)(_unref(baDocs).financialServicesGuide.title),
                          target: "_blank"
                        }, _toDisplayString(_ctx.$t(`title.${_unref(baDocs).financialServicesGuide.title}`)), 9, _hoisted_107),
                        _createTextVNode(", "),
                        _createElementVNode("a", {
                          href: _unref(getBaDocs)(_unref(baDocs).targetMarketDetermination.title),
                          target: "_blank"
                        }, _toDisplayString(_ctx.$t(`title.${_unref(baDocs).targetMarketDetermination.title}`)), 9, _hoisted_108),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.andHaveSought")) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((checked).value = $event))
                        }, null, 512), [
                          [_vModelCheckbox, checked.value]
                        ]),
                        _hoisted_109
                      ]))
                    : _createCommentVNode("", true),
                  (tenantNo.value == _unref(TenantTypes).jp)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_110))
                    : (
                c.value[0] == _unref(SiteTypes).Australia || tenantNo.value == _unref(TenantTypes).au
              )
                      ? (_openBlock(), _createElementBlock("label", _hoisted_111, [
                          _createTextVNode(_toDisplayString(_ctx.$t("tip.byCreateAccountYouAgree")) + " ", 1),
                          _createElementVNode("a", {
                            href: _unref(getBaDocs)(_unref(baDocs).termAndConditions.title),
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t(`title.${_unref(baDocs).termAndConditions.title}`)), 9, _hoisted_112),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.and")) + " ", 1),
                          _createElementVNode("a", {
                            href: _unref(getBaDocs)(_unref(baDocs).privacyPolicy.title),
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t(`title.${_unref(baDocs).privacyPolicy.title}`)), 9, _hoisted_113),
                          _createTextVNode(" . "),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((checkedTwo).value = $event))
                          }, null, 512), [
                            [_vModelCheckbox, checkedTwo.value]
                          ]),
                          _hoisted_114
                        ]))
                      : (_openBlock(), _createElementBlock("label", _hoisted_115, [
                          _createTextVNode(_toDisplayString(_ctx.$t("tip.byCreateAccountYouAgree")) + " ", 1),
                          _createElementVNode("a", {
                            href: _unref(getBviDocs)(_unref(bviDocs).termsAndConditions.title),
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t(`title.${_unref(bviDocs).termsAndConditions.title}`)), 9, _hoisted_116),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.and")) + " ", 1),
                          _createElementVNode("a", {
                            href: _unref(getBviDocs)(_unref(bviDocs).privacyPolicy.title),
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t(`title.${_unref(bviDocs).privacyPolicy.title}`)), 9, _hoisted_117),
                          _createTextVNode(" . "),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((checkedTwo).value = $event))
                          }, null, 512), [
                            [_vModelCheckbox, checkedTwo.value]
                          ]),
                          _hoisted_118
                        ]))
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  ref_key: "submitButton",
                  ref: submitButton,
                  class: "submitBtn",
                  disabled: !checked.value || !checkedTwo.value
                }, [
                  _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.$t("action.submit")), 1),
                  _createElementVNode("span", _hoisted_121, [
                    _createTextVNode(_toDisplayString(_ctx.$t("tip.pleaseWait")) + " ", 1),
                    _hoisted_122
                  ])
                ], 8, _hoisted_119)
              ]),
              _: 1
            }, 8, ["validation-schema"]))
          : _createCommentVNode("", true),
        (processes.value == 3)
          ? (_openBlock(), _createBlock(_unref(Form), { key: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("tip.verifyYourEmail")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_126, [
                          _createTextVNode(_toDisplayString(_ctx.$t("tip.thankSignUpAndConfirm")) + " ", 1),
                          _createElementVNode("a", _hoisted_127, _toDisplayString(formData.value.email), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.toActivateYourAccount")), 1)
                        ]),
                        _hoisted_128,
                        _createElementVNode("div", _hoisted_129, [
                          _createTextVNode(_toDisplayString(_ctx.$t("tip.linkExpireContact")) + " ", 1),
                          _createVNode(_component_router_link, { to: "/lead-create" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("title.contactUs")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_130,
                        _createElementVNode("div", _hoisted_131, [
                          _createTextVNode(_toDisplayString(_ctx.$t("tip.notReceiveEmail")) + " ", 1),
                          _createElementVNode("a", {
                            class: "ms-3",
                            href: "#",
                            onClick: resendConfirmation
                          }, _toDisplayString(_ctx.$t("action.resendEmail")), 1)
                        ])
                      ]),
                      _hoisted_132
                    ]),
                    _hoisted_133
                  ]),
                  _createElementVNode("button", {
                    class: "changeEmailBtn text-uppercase",
                    type: "button",
                    onClick: goLogin
                  }, _toDisplayString(_ctx.$t("tip.backToLogin")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_134, [
          _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.$t("action.login")), 1),
          _createVNode(AuthSwitch, {
            isEnabled: authType.value,
            color: "#F5BF21",
            onToggleAuthType: toggleAuthType
          }, null, 8, ["isEnabled"]),
          _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.$t("action.register")), 1)
        ])
      ])
    ])
  ]))
}
}

})